<template>
  <div class="chunengdanyuan-box">
    <title1 type="1" title="电池堆监控" />
	<div class="main-title">
		{{infoObj.arr_name}}
	</div>
	<div class="main-box">
		<div class="cell">
			<div class="top">总电流</div>
			<div class="bottom">
				<span><span class="num">{{infoObj.current || 0}}</span>A</span>
			</div>
		</div>
		<div class="cell">
			<div class="top">总电压</div>
			<div class="bottom">
				<span><span class="num">{{infoObj.voltage || 0}}</span>V</span>
			</div>
		</div>
		<div class="cell">
			<div class="top">最大放电功率</div>
			<div class="bottom">
				<span><span class="num">{{infoObj.max_discharge_power || 0}}</span>kW</span>
			</div>
		</div>
		<div class="cell">
			<div class="top">最高温度</div>
			<div class="bottom">
				<span><span class="num">{{infoObj.max_temp || 0}}</span>°C</span>
			</div>
		</div>
		<div class="cell">
			<div class="top">最低温度</div>
			<div class="bottom">
				<span><span class="num">{{infoObj.min_temp || 0}}</span>°C</span>
			</div>
		</div>
		<div class="cell">
			<div class="top">最大充电功率</div>
			<div class="bottom">
				<span><span class="num">{{infoObj.max_charge_power || 0}}</span>kW</span>
			</div>
		</div>
		<div class="cell">
			<span class="soc">soc</span> <span class="number"><span class="num" style="margin-right:5px">{{infoObj.soc}}</span>%</span>
		</div>
		<img class="mainimg" src="@/assets/images/energyStorage/chunengdanyuan.png" alt="">
		
		<img v-if="infoObj.arr_status==1" class="mainimg1" src="@/assets/images/energyStorage/chongdianzhong.png" alt="">
		<img v-if="infoObj.arr_status==0" class="mainimg1" src="@/assets/images/energyStorage/zanting.png" alt="">
		<img v-if="infoObj.arr_status==3" class="mainimg1" src="@/assets/images/energyStorage/daiji.png" alt="">
		<img v-if="infoObj.arr_status==4" class="mainimg1" src="@/assets/images/energyStorage/guzhang.png" alt="">
		<img v-if="infoObj.arr_status==2" class="mainimg1" src="@/assets/images/energyStorage/fangdianzhong.png" alt="">
	</div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title1";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1
  },
  data() {
    return {
		infoObj: {}
	};
  },
  destroyed() {
    this.$bus.$off('bigScreen::storedEnergyId')
  },
  mounted() {
    this.$bus.$on("bigScreen::storedEnergyId", () => {
      this.getChunengduanyuan()
    })
	this.getChunengduanyuan()
  },
  methods: {
    getChunengduanyuan() {
	  let _this = this
	  let params = {
		'enCode': "chuneng-quanguo-cndyjk",
		'@energyId': localStorage.getItem('bigScreen::storedEnergyId') || 'ES00001'
	  }
	  dataInterface.dataFaceApi(params).then((res) => {
		if (!res || !res.length) return
			// console.log(res, '储能单元监控')
			this.infoObj = res[0]
	  })
	  .catch((err) => {
		console.log(err, 'error');
	  })
    }
  },
};
</script>

<style lang="scss" scope>
@import "@/views/components/energyStorage/comm.scss";
.chunengdanyuan-box {
	.main-title{
		font-family:'PMZD';
		height: 80px;
		line-height: 80px;
		width: 100%;
		text-align: center;
		font-size: 36px;
		// font-weight: 600;
		letter-spacing:3px;
		width: 550px;
	}
	.main-box{
		width:550px;
		height: 300px;
		text-align: center;
		position: relative;
		.mainimg{
			width: 300px;
			height: 300px;
		}
		.mainimg1{
			width: 100px;
			position: absolute;
			left: 50%;
			margin-left: -50px;
			top: 0px;
		}
		.cell{
			font-size: 24px;
			width: 180px;
			.soc{
				font-family:'PMZD';
				margin-right: 10px;
			}
			.top{
				height: 30px;
				line-height: 20px;
			}
			.bottom{
				color:#31C6C9;
				height: 30px;
				line-height: 30px;
				span{
					
					// font-weight: 600;
					.num{
						margin-right: 3px;
						font-size: 32px;
						font-family: "HT";
					}
				}
			}
		}
		.cell:nth-child(1) {
			position: absolute;
			left: -25px;
			top: 10px;
			text-align: right;
		}
		.cell:nth-child(2) {
			position: absolute;
			left: -25px;
			top: 100px;
			text-align: right;
		}
		.cell:nth-child(3) {
			position: absolute;
			left: -25px;
			top: 190px;
			text-align: right;
		}
		.cell:nth-child(4) {
			position: absolute;
			right: -25px;
			top: 10px;
			text-align: left;
		}
		.cell:nth-child(5) {
			position: absolute;
			right: -25px;
			top: 100px;
			text-align: left;
		}
		.cell:nth-child(6) {
			position: absolute;
			right: -25px;
			top: 190px;
			text-align: left;
		}
		.cell:nth-child(7) {
			position: absolute;
			font-size: 30px;
			width: 200px;
			color: #FFD15C;
			left: 50%;
			margin-left: -100px;
			bottom: -16px;
			text-align: center;
			.number{
				font-size: 34px;
				// font-weight: 600;
				.num{
						font-family: "HT";
					}
			}
		}
	}
}
</style>
